'use client';

import React from "react";
import PropTypes from 'prop-types';
import MapMarker from './MapMarker';

ClinicKey.propTypes = {
    markers: PropTypes.object.isRequired,
    margin: PropTypes.bool,
    right: PropTypes.bool
};

export default function ClinicKey({
    markers,
    margin = false,
    right = false
}) {
    return (
        <div className={`clinic-finder-key ${right ? 'clinic-finder-key--right' : ''} ${margin ? 'clinic-finder-key--margin' : ''}`}>
            <span className="clinic-finder-key__item">
                <MapMarker type="flagship" className="clinic-finder-key__icon" />
                {markers.blue ? markers.blue : 'Private Clinic'}
            </span>
            <span className="clinic-finder-key__item">
                <MapMarker type="pharmacy" className="clinic-finder-key__icon" />
                {markers.blue ? markers.teal : 'Pharmacy'}
            </span>
        </div >
    )
}